<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showConfigAcumulada"
    no-close-on-backdrop
    scrollable
    title="Config Acumulada"
    cancel-variant="outline-secondary"
    ok-only
    @hidden="onlyClose"
  >
    <span style="display:none">{{ categoria }}</span>
    <v-select
      :options="listCampeonatos"
      @input="changeCampeonato"
      placeholder="Sel. Camp"
      :clearable="false"
      v-model="campeonatoSeleccionado"
    />
    <div class="mt-2 mb-1">
      Seleccione las etapas que desea agrupar para la tabla acumulada
    </div>
    <b-overlay :show="showLoading" rounded="sm">
      <b-form-checkbox
        v-for="option in listEtapas"
        :key="option.value"
        v-model="etapaSelected"
        :value="option.value"
        name="flavour-3a"
        style="margin: 10px;"
        :disabled="idConfig !== null ? true : false"
      >
        {{ option.text }}
      </b-form-checkbox>
      <b-row v-for="item in listOpciones" :key="item.id">
        <b-col>
          <b-form-radio
            v-model="radioSelected"
            name="some-radios"
            :value="item.id_radio"
            :disabled="idConfig !== null ? true : false"
          >
            <small> {{ item.name }} </small>
            <p style="font-size:10px; color:gray">{{ item.descripcion }}</p>
          </b-form-radio>
        </b-col>
      </b-row>
    </b-overlay>
    <template #modal-footer>
      <div class="w-100">
        <template>
          <b-button
            v-if="
              USER().rol === `${ROLES.ADMIN}` ||
                USER().rol === `${ROLES.SUPER}` ||
                USER().rol === ROLES.TECNICA
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="idConfig !== null ? 'danger' : 'primary'"
            class="float-right"
            @click="saveDelete()"
          >
            <span>{{ idConfig !== null ? 'Eliminar' : 'Guardar' }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>

        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>
<script>
import vSelect from 'vue-select'
import {
  BModal,
  BButton,
  BAlert,
  BOverlay,
  BFormCheckbox,
  BFormRadio,
  BRow,
  BCol,
  // xx
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { heightFade } from '@core/directives/animations'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
  //   ESTADO_JUGADOR,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    vSelect,
    BButton,
    BAlert,
    BOverlay,
    BFormCheckbox,
    BFormRadio,
    BRow,
    BCol,
  },
  props: {
    listCampeonatos: Array,
    categoria: String,
  },
  directives: {
    Ripple,
    heightFade,
  },
  setup(props) {
    const listEtapas = ref([])
    const listOpciones = ref([])
    const etapaSelected = ref([])
    const messageError = ref('')
    const variante = ref('danger')
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const hasError = ref(false)
    const showLoading = ref(false)
    const radioSelected = ref(null)
    const idConfig = ref(null)
    const totalGrupos = ref(0)
    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })
    const { postApi, getApi } = apiCall()
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    async function changeCampeonato() {
      listEtapas.value = []
      listOpciones.value = []
      showLoading.value = true
      const path = `ApiConfiguration/getConfigAcumulada/${campeonatoSeleccionado.value.value}/${props.categoria}`
      const response = await getApi(URL, path)
      const etapas = response.data
      listOpciones.value = response.opciones
      idConfig.value = response.idConfig
      radioSelected.value = response.opcionId
      totalGrupos.value = response.totalGrupos
      if (etapas.length !== 0) {
        etapas.forEach(element => {
          const obj = {
            text: `etapa ${element.etapa}`,
            value: element.etapa,
          }
          listEtapas.value.push(obj)
        })
      }
      showLoading.value = false
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function reset() {
      radioSelected.value = null
      etapaSelected.value = []
      countDownChanged(0)
    }
    async function insertConfiguration() {
      const path = 'ApiConfiguration/insertConfigAcumulada'
      const dataSend = {
        rol: USER().rol,
        id_campeonato: campeonatoSeleccionado.value.value,
        id_categoria: props.categoria,
        opcion: radioSelected.value,
        etapas: etapaSelected.value,
        max_grupos: totalGrupos.value,
      }
      if (etapaSelected.value.length === 0) {
        showMessageAlert('danger', 'Seleccione al menos una etapa')
        return
      }
      if (radioSelected.value === null) {
        showMessageAlert('danger', 'Seleccione una opción')
        return
      }
      //   rol, id_jugador, id_equipo, num_camiseta
      const response = await postApi(URL, path, dataSend)
      // console.log(response)
      if (response.flag === 'si') {
        showMessageAlert('success', 'Configuración creada exitosamente')
        reset()
        changeCampeonato()
      } else {
        showMessageAlert('danger', response.mensaje)
      }
    }
    async function deleteConfiguration() {
      showLoading.value = true
      const path = 'ApiConfiguration/deleteConfigAcumulada'
      const dataSend = {
        rol: USER().rol,
        id_config: idConfig.value,
      }
      //   rol, id_jugador, id_equipo, num_camiseta
      const response = await postApi(URL, path, dataSend)
      // console.log(response)
      if (response.flag === 'si') {
        showMessageAlert('success', 'Configuración eliminada exitosamente')
        reset()
        changeCampeonato()
      } else {
        showMessageAlert('danger', response.mensaje)
      }
    }
    function saveDelete() {
      if (idConfig.value !== null) {
        deleteConfiguration()
      } else {
        insertConfiguration()
      }
    }

    function onlyClose() {
      campeonatoSeleccionado.value = null
      listEtapas.value = []
      listOpciones.value = []
      showLoading.value = false
      idConfig.value = null
      totalGrupos.value = 0
      reset()
      store.commit('someVariables/UPDATE_SHOW_CONFIG_ACUMULADA', false)
    }

    return {
      avatarText,
      messageError,
      variante,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      showMessageAlert,
      hasError,
      onlyClose,
      reset,
      showLoading,
      changeCampeonato,
      campeonatoSeleccionado,
      listEtapas,
      etapaSelected,
      radioSelected,
      listOpciones,
      USER,
      ROLES,
      idConfig,
      saveDelete,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
